module.exports = __webpack_public_path__ + "static/media/Trophy.510e7222.png";